/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

import { Colors, Typography } from '../../../theme';
import { IconButton } from '../../navigation/IconButton';
import { Link } from '../../navigation/Link';

type Props = {
  /**
   * The text to render next to the back button.
   */
  children: string;
  /**
   * Where the back button should link to.
   */
  href?: string;
  /**
   * Optional click handler.
   */
  onClick?: React.MouseEventHandler;
};

const Styles = labelStyles('BackButton', {
  root: css`
    ${Typography.subtitle800};
    color: ${Colors.black};
    align-items: center;
    display: grid;
    grid-gap: 15px;
    grid-template-columns: auto 1fr;
  `,
});

export const BackButton = (props: Props) => {
  return (
    <Link
      color={null}
      css={Styles.root}
      href={props.href}
      onClick={props.onClick}
    >
      <IconButton icon="arrowBigLeft" presentationOnly={true} />
      <p>{props.children}</p>
    </Link>
  );
};
